import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
import { getAuthToken } from '../../utils/api';

interface Props {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<Props> = ({ children }) => {
  const { userProfile, isLoading } = useUser();
  const location = useLocation();

  if (!getAuthToken()) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/sign-in?next=${next}`} replace />;
  }

  if (isLoading) return null;

  if (!userProfile) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/sign-in?next=${next}`} replace />;
  }

  if (userProfile.is_banned) {
    return <Navigate to="/banned" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
